import RouteView from '../../router/RouteView.vue';
import Mamange from './manage/index.vue';
import ManageYun from './manageYun/index.vue';

export default [
  {
    path: '/manage',
    name: 'Courseware',
    component: RouteView,
    redirect: '/manage',
    meta: {
      title: '课件',
    },
    children: [
      {
        path: '/manage',
        name: 'Mamange',
        component: Mamange,
        meta: {
            title: '双师课件管理'
        }
      },
      {
        path: '/manageYun',
        name: 'manageYun',
        component: ManageYun,
        meta: {
            title: '擎想系统课件管理'
        }
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/views/Courseware/index.js